import { useContext, useEffect, useMemo } from 'react';
import { Divider, Flexbox, Grid } from '@sede-enterprise/shell-ds-react-framework';
import { AppContext } from '../../../../Context/AppContext';
import { DataValidationCheckView } from './DataValidationCheckView';
import NcfReportingHomeHeader from '../NcfReportingUtils/NcfReportingHomeHeader/NcfReportingHomeHeader';
import { UncategorisedCptyView } from './UncategorisedCptyView';
import { InactiveCptyView } from './InactiveCptyView';
import { BiaReportsFilterSection } from './BiaReportsFilterSection';
import BiaDateSideCard from './BiaDateSideCard/BiaDateSideCard';
import { NcfServerErrorMessage } from '../NcfReportingUtils/NcfServerErrorMessage';
import { ASIA_JAPAN } from '../../../../api/constants';
import PipelineRunMessageOverlay from '../PipelineRunMessage/PipelineRunMessageOverlay';

export const BiaReportPage = () => {
  const { state: appDataState, dispatch: appDataDispatch } = useContext(AppContext).appData;
  const { state, dispatch } = useContext(AppContext).biaReports;
  const userRegion = localStorage.getItem('userRegion') ?? appDataState.userRegion;
  const isAsiaUser =
    localStorage.getItem('isAsiaUser') !== null
      ? localStorage.getItem('isAsiaUser') === 'true'
      : appDataState.userRegionFlags.isAsiaUser;
  useEffect(() => {
    appDataDispatch({ type: 'setCurrentPage', payload: '' });
  }, []);

  useEffect(() => {
    if (userRegion !== '') {
      let payloadRegion = userRegion;
      if (isAsiaUser) {
        payloadRegion = ASIA_JAPAN;
      }
      dispatch({
        type: 'setBiaFilterData',
        payload: {
          ...state.biaFilterData,
          biaRegion: payloadRegion,
        },
      });
    }
  }, []);

  const isRegionEurope = useMemo(
    () => state.biaFilterData.biaRegion.toLowerCase() === 'europe',
    [state.biaFilterData.biaRegion],
  );
  const isRegionEuropeAmericas = useMemo(
    () => isRegionEurope ?? state.biaFilterData.biaRegion.toLowerCase() === 'americas',
    [isRegionEurope, state.biaFilterData.biaRegion],
  );

  return (
    <div style={{ height: '100%', background: '#F5F5F5' }} data-testid='analytics-home'>
      <Flexbox gap='24px 24px' style={{ marginLeft: '15px', justifyContent: 'start' }}>
        <BiaReportsFilterSection />
        <Grid gap='10px'>
          <Grid.Cell>
            <Flexbox justifyContent='space-between'>
              <NcfReportingHomeHeader
                title='BIA Reports'
                description='Data Validation Reports for Historic Gas and Power Volumes'
              />
              <BiaDateSideCard />
            </Flexbox>
          </Grid.Cell>
          <Divider size='medium' direction='horizontal' />
          <div style={{ position: 'relative' }}>
            <PipelineRunMessageOverlay show={state.isAnyBiaPrimaryApiResponseEmpty} />
            <div>
              <Grid.Cell>
                <div style={{ width: '99%' }}>
                  <DataValidationCheckView />
                </div>
                <NcfServerErrorMessage />
              </Grid.Cell>
              <Grid.Cell>
                {isRegionEuropeAmericas ? (
                  <div style={{ width: '99%' }}>
                    <Flexbox alignContent='flex-start' gap='15px'>
                      <div style={{ width: '50%' }}>
                        <UncategorisedCptyView />
                      </div>
                      <div style={{ width: '50%' }}>
                        <InactiveCptyView />
                      </div>
                    </Flexbox>
                  </div>
                ) : (
                  <div style={{ width: '99%' }}>
                    <UncategorisedCptyView />
                  </div>
                )}
              </Grid.Cell>
            </div>
          </div>
        </Grid>
      </Flexbox>
    </div>
  );
};